import React from 'react'
import { Link } from 'react-router-dom'


const About = () => <div>
  <h3>About</h3>
  <Link to="/">Home</Link>
</div>


export default About;


// WEBPACK FOOTER //
// ./src/components/About.js